import { render, staticRenderFns } from "./GradeUpdate.vue?vue&type=template&id=cf0e48a0&"
import script from "./GradeUpdate.vue?vue&type=script&lang=ts&"
export * from "./GradeUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports